import Vue from "vue"
import App from "./App"
import store from "./store"
import router from "./router.js"
import BootstrapVue from "bootstrap-vue"
import "bootstrap/dist/css/bootstrap.css"
import "bootstrap-vue/dist/bootstrap-vue.css"

Vue.use(BootstrapVue)

Vue.config.productionTip = false

window.Office.initialize = () => {
  new Vue({
    el: "#app",
    store,
    router,
    render: h => h(App)
  }).$mount('#app')
}
